export default {
  tenantPdfTemplates: [],
  tenantPdfTemplate: null
}
